



































































































































































































































































































































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { Usuario } from '../../../../back/src/entity/Usuario';
import { Acompanhamento } from '../../../../back/src/types';

import { calculoIdadeGestacional, getDpp, montaFlagsAarray } from '../../utils/functions';

import CustomDialog from '../CustomDialog.vue';
import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import TheGestacoesResponsavelForm from '../gestacoes/TheGestacoesResponsavelForm.vue';
import { Internacao } from '../../../../back/src/entity/Internacao';
import { avisosGestacao } from '../../utils/constants';

export default Vue.extend({
  name: 'ThePacientesGestantesPreNatalTabela',
  components: {
    CustomDialog,
    IfEmptyTextPrintNA,
    TheGestacoesResponsavelForm,
  },
  props: {
    pacientes: {
      type: Array as () => Paciente[],
      required: true,
    },
    usuarios: {
      type: Array as () => Usuario[],
      required: true,
    },
  },
  data() {
    return {
      dialogResponsavel: false,
      anoMesResponsavel: null,
      gestacoesIdsResponsavel: [],
      showAlterarResponsavel: false,
      showSnackbarResponsavel: false,
      colorsMeses: {
        '01': { text: 'Janeiro', color: 'red' },
        '02': { text: 'Fevereiro', color: 'indigo' },
        '03': { text: 'Março', color: 'teal' },
        '04': { text: 'Abril', color: 'deep-orange' },
        '05': { text: 'Maio', color: 'pink' },
        '06': { text: 'Junho', color: 'blue' },
        '07': { text: 'Julho', color: 'lime' },
        '08': { text: 'Agosto', color: 'orange' },
        '09': { text: 'Setembro', color: 'purple' },
        10: { text: 'Outubro', color: 'cyan' },
        11: { text: 'Novembro', color: 'green' },
        12: { text: 'Dezembro', color: 'amber' },
        indefinido: { text: 'DPP não definida', color: 'grey' },
      },
    };
  },
  computed: {
    gestantes() {
      return _.groupBy(
        _.orderBy(
          _.map(this.pacientes, paciente => this.montaGestante(paciente)),
          ['dpp'],
        ),
        gestante => gestante.anoMes,
      );
    },
  },
  methods: {
    selecionaResponsavelAnoMes(anoMes, value) {
      this.gestacoesIdsResponsavel = value
        ? _.map(this.gestantes[anoMes], gestante => gestante.gestacaoId)
        : [];
    },
    selecionaResponsavelGestante(anoMes) {
      const allSelected = _.reduce(
        this.gestantes[anoMes],
        (result, gestante) => result && this.gestacoesIdsResponsavel.includes(gestante.gestacaoId),
        true,
      );
      this.anoMesResponsavel = allSelected ? anoMes : null;
    },
    alterarResponsavel() {
      this.anoMesResponsavel = null;
      this.gestacoesIdsResponsavel = [];
      this.showAlterarResponsavel = true;
      this.showSnackbarResponsavel = true;
    },
    cancelaAlterarReponsavel() {
      this.anoMesResponsavel = null;
      this.gestacoesIdsResponsavel = [];
      this.showAlterarResponsavel = false;
      this.showSnackbarResponsavel = false;
      this.dialogResponsavel = false;
      this.$emit('cancela-alterar-responsavel');
    },
    atualizaResponsavel(responsavelId) {
      this.$emit('atualiza-responsavel', {
        responsavelId,
        gestacoesIds: this.gestacoesIdsResponsavel,
      });
      this.cancelaAlterarReponsavel();
    },
    montaGestante(paciente: Paciente) {
      const dpp = getDpp(paciente.gestacao_atual);
      const anoMes = dpp ? moment(dpp).utc().format('YYYY-MM') : 'indefinido';
      return {
        id: paciente.id,
        gestacaoId: _.get(paciente, 'gestacao_atual.id', null),
        paciente,
        responsavelId: [Acompanhamento.COLETIVO, Acompanhamento.CASA_DE_PARTO].includes(
          paciente.acompanhamento as Acompanhamento,
        )
          ? _.get(paciente, 'gestacao_atual.responsavel_id', null)
          : paciente.responsavel_id,
        responsavel: [Acompanhamento.COLETIVO, Acompanhamento.CASA_DE_PARTO].includes(
          paciente.acompanhamento as Acompanhamento,
        )
          ? _.get(paciente, 'gestacao_atual.responsavel', null)
          : paciente.responsavel,
        nome: paciente.nome,
        internacaoAgendadaId: paciente.internacoes
          ? this.internacaoAgendadaId(paciente.internacoes)
          : null,
        internacaoAtivaId: paciente.internacoes
          ? this.internacaoAtivaId(paciente.internacoes)
          : null,
        dpp,
        anoMes,
        ig: calculoIdadeGestacional(paciente.gestacao_atual),
        paridade: paciente.paridade,
        datetime_triagem: _.get(paciente, 'gestacao_atual.datetime_triagem', null),
        localParto: _.get(paciente, 'gestacao_atual.local_parto', null),
        pediatra: _.get(paciente, 'gestacao_atual.pediatra', null),
        statusObservacoes: paciente.status_observacoes,
        observacoes: paciente.observacoes,
        flags: this.getflags(paciente.gestacao_atual),
        endereco: paciente.cidade !== 'São Paulo' ? paciente.cidade : paciente.bairro,
        telefone: paciente.telefone2
          ? `${paciente.telefone1} / ${paciente.telefone2}`
          : paciente.telefone1,
      };
    },
    internacaoAgendadaId(internacoes: Internacao[]) {
      const internacaoAgendada = _.find(
        internacoes,
        internacao => (
          internacao.datetime_agendamento
          && !internacao.datetime_internacao
          && !internacao.cancelled
        ),
      );
      return _.get(internacaoAgendada, 'id', null);
    },
    internacaoAtivaId(internacoes: Internacao[]) {
      const internacaoAtiva = _.find(
        internacoes,
        internacao => (
          internacao.datetime_internacao
          && !internacao.data_alta
          && !internacao.cancelled
        ),
      );
      return _.get(internacaoAtiva, 'id', null);
    },
    getColorMes(anoMes) {
      const mes = _.last(anoMes.split('-')) as string;
      if (_.has(this.colorsMeses, mes)) {
        return this.colorsMeses[mes];
      }
      return this.colorsMeses.indefinido;
    },
    getColorMesClass(anoMes) {
      return _.get(this.getColorMes(anoMes), 'color', '');
    },
    getColorMesText(anoMes) {
      const ano = _.first(anoMes.split('-')) as string;
      if (ano && ano !== 'indefinido') {
        return `${_.get(this.getColorMes(anoMes), 'text', '')} de ${ano}`;
      }
      return _.get(this.getColorMes(anoMes), 'text', '');
    },
    getflags(gestacao: Gestacao): { sigla: string, descricao: string, color: string }[] {
      return montaFlagsAarray(gestacao);
    },
  },
});
